/**
 * Takes a mosaic image identifier and generates image URLs from it
 *
 * Parse: `//img.chewy.com/is/image/catalog/88789_MAIN,1598643069`, 150
 * Into:  `//img.chewy.com/is/catalog/88789_MAIN._AC_SY150_V1598643069_.jpg`
 * @param {string} image mosaic image identifier
 * @param {number} size
 * @param {string} type 'AC_SY' | 'SS'
 */
function getImageUrl(
  image: string,
  size: number = 150,
  type: 'AC_SY' | 'SS' | 'AC_SS' | 'AC_SX' = 'AC_SY',
) {
  //img.chewy.com/image/93AF2603F1E9FA16EF0397B9A1FFEF71
  if (!image) return;
  const urlPrefix = image.startsWith('//') ? `https:${image}` : image;
  const urlParts = urlPrefix.split(',');
  const isCatalogImage = urlParts.length === 2;
  return isCatalogImage
    ? `${urlParts[0]}._${type}${size}_V${urlParts[1]}_.jpg`
    : `${urlParts[0]}._${type}${size}_.jpg`;
}

export default getImageUrl;
